const menuCompare = {
  ACCOUNT_USER_LIST_EDIT: 1,
  ACCOUNT_USER_LIST_VIEW: 2,
}
export default menuCompare



// WEBPACK FOOTER //
// ./src/utils/menuCompare.js